<template>
  <LayoutSection :maxWidthClass="'max-w-[1100px] mx-auto'">
    <SubContent paddingClass="p-[2.4rem]">
      <div class="flex flex-wrap">
        <div class="md:w-5/5">
          <div>
            <h3
              class="text-black text-[18px] sm:text-[1.8rem] md:text-[2.6rem] font-semibold leading-[1.15] tracking-[-0.78px]"
            >
              {{ $t("Are you a healthcare specialist?") }}
              <br />
              {{ $t("Acquire new patients with Medkus.") }}
            </h3>
            <p
              class="max-w-[65.1rem] text-black leading-[1.6] px-0 py-[2.4rem]"
            >
              {{
                $t(
                  "Grow your practice by allowing clients to book appointments anytime — day or night — without relying on opening hours. Forget manual scheduling: our platform automates bookings so you can focus on what matters most — supporting your clients. Boost your online reputation with verified reviews and increase your visibility in a trusted, professional environment",
                )
              }}.
            </p>

            <CustomButton
              :label="$t('Discover Medkus')"
              @click="$router.push('/for-professionals')"
            />
          </div>
        </div>
        <!-- <div class="md:w-2/5 pr-4 pl-4">
          <div class="w-full h-full">
            <img
              class="w-full h-full"
              src="@/assets/images/white-flower-image.png"
              alt="health specialist"
            />
          </div>
        </div> -->
      </div>
    </SubContent>
  </LayoutSection>
</template>

<script>
import CustomButton from "@/components/buttons/customButton.vue";
import { defineComponent } from "vue";
import SubContent from "@/components/design/subContent.vue";
import LayoutSection from "@/components/design/layoutSection.vue";

export default defineComponent({
  name: "HealthSpecialistSection",
  components: {
    CustomButton,
    SubContent,
    LayoutSection,
  },
});
</script>

<style scoped>
.health_specialis_box {
  background: linear-gradient(174deg, #fff 11.67%, #f7f9fa 82.14%);
}
</style>
